import React, {useContext} from "react";
import {AuthUserContext} from "../providers/AuthProvider";
import {Navigate, Outlet, useLocation, useNavigate} from "react-router-dom";
import Container from "@mui/material/Container/Container";
import Grid from "@mui/material/Grid/Grid";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";

const ProtectedRoute = ({children}) => {
  const { user, profile } = useContext(AuthUserContext);
  const [open, setOpen] = React.useState(true);
  const location = useLocation()
  const navigate = useNavigate()
  const isPanelPattern = /pending-project-details|live-project-details|chat|notification-center/
  const handleClick = () => {
    setOpen(!open);
  };
  if (!user) {
    return <Navigate to={'/auth/who-are-you'} replace />;
  }

  return children ? children :profile &&  profile?.userType === 'admin' &&  !isPanelPattern.test(location.pathname) ?
    <Container maxWidth={'full-width'} sx={{paddingLeft:'0px'}} disableGutters={true}>
      <Grid container direction="row"
            justifyContent="flex-start"
      >
        <Grid  sx={{backgroundColor: '#204488', width: 300, height: 'calc(100vh - 116px)'}}>

          <List
            sx={{ width: '100%', maxWidth: 300, color:'#bcbcbc' ,  pl: 5, py: 5, textTransform:'uppercase' }}
            component="nav"

          >
            <ListItemButton sx={{backgroundColor: location?.pathname === '/admin/user-analytics' ? '#ffffff10' : 'none', textDecoration: location?.pathname === '/admin/user-analytics'? 'underline':'none'}} onClick={() => navigate('/admin/user-analytics')}>
              <ListItemText primary="User Analytics"  />
            </ListItemButton>

            <ListItemButton onClick={handleClick}>
              <ListItemText primary="Users" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{backgroundColor: location?.pathname === '/admin/user-list'
                  || location?.pathname === '/admin/user-list-creator' ? '#ffffff10' : 'none',  pl: 4 , textDecoration: location?.pathname === location?.pathname === '/admin/user-list'
                  || location?.pathname === '/admin/user-list-creator'? 'underline':'none'}} onClick={() => navigate('/admin/user-list')}>
                  <ListItemText primary="User List" />
                </ListItemButton>
                <ListItemButton sx={{backgroundColor: location?.pathname === '/admin/user-pending' ? '#ffffff10' : 'none',  pl: 4,  textDecoration: location?.pathname === '/admin/user-pending'? 'underline':'none' }} onClick={() => navigate('/admin/user-pending')}>
                  <ListItemText primary="Pending Users" />
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton sx={{backgroundColor: location?.pathname === '/admin/project-pending' ? '#ffffff10' : 'none', textDecoration: location?.pathname === '/admin/project-pending'? 'underline':'none'}} onClick={() => navigate('/admin/project-pending')}>
              <ListItemText primary="Pending Projects"  />
            </ListItemButton>
            {profile?.super && <>

              <ListItemButton  sx={{backgroundColor: location?.pathname === '/admin/project-live' || location?.pathname === '/admin/project-management' ? '#ffffff10' : 'none', textDecoration:location?.pathname === '/admin/project-live' || location?.pathname === '/admin/project-management'? 'underline':'none'}}  onClick={() => navigate('/admin/project-live')}>
                <ListItemText primary="Live Projects"/>
              </ListItemButton>
              <ListItemButton  sx={{backgroundColor: (location?.pathname === '/admin/manage' || location?.pathname === '/admin/manage-admin-details' ) ? '#ffffff10' : 'none', textDecoration: (location?.pathname === '/admin/manage' || location?.pathname === '/admin/manage-admin-details' ) ? 'underline':'none'}}  onClick={() => navigate('/admin/manage')}>
                <ListItemText primary="Manage Admin"/>
              </ListItemButton>

            </>}

          </List>
        </Grid>
        <Grid sx={{width: 'calc(100% - 310px)'}} >
          <Outlet />
        </Grid>

      </Grid>
    </Container> : <Outlet />;
};

export default ProtectedRoute;